import { BreadType } from 'types/bread'
import { db, FirebaseDocRefType } from 'firebase/index'

export const fetchBreadByRef = (breadRef: FirebaseDocRefType): Promise<BreadType | undefined> => {
  return breadRef
    .get()
    .then((snapshot) => {
      const data = snapshot.data() as BreadType
      data.bread_ref = snapshot.ref
      return data
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchBreads = (statuses: string[]): Promise<BreadType[]> => {
  return db
    .collection('breads')
    .where('status', 'in', statuses)
    .orderBy('name', 'asc')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data() as BreadType
        data.bread_ref = snapshot.ref
        return data
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}
